import { render, staticRenderFns } from "./LabelAssignDialog.vue?vue&type=template&id=7b49d9d7&scoped=true"
import script from "./LabelAssignDialog.vue?vue&type=script&lang=js"
export * from "./LabelAssignDialog.vue?vue&type=script&lang=js"
import style0 from "./LabelAssignDialog.vue?vue&type=style&index=0&id=7b49d9d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b49d9d7",
  null
  
)

export default component.exports